'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../buttons/ClearButton/ClearButton.js');
var SecondaryButton = require('../buttons/SecondaryButton/SecondaryButton.js');
var Popover = _interopDefault(require('@material-ui/core/Popover'));
require('../typography/ErrorText/ErrorText.js');
require('../typography/LargeDarkText/LargeDarkText.js');
require('../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../typography/MediumDarkText/MediumDarkText.js');
var MediumEmphasizedDarkText = require('../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
var MediumText = require('../typography/MediumText/MediumText.js');
require('../typography/MediumWhiteText/MediumWhiteText.js');
require('../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../typography/SmallDarkText/SmallDarkText.js');
require('../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../typography/SmallDisabledText/SmallDisabledText.js');
require('../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../typography/SmallLinkText/SmallLinkText.js');
require('../typography/SmallTitleText/SmallTitleText.js');
require('../typography/SmallWhiteText/SmallWhiteText.js');
require('../typography/TinyDarkText/TinyDarkText.js');
require('../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../typography/TinyLinkText/TinyLinkText.js');
require('../typography/TinyTitleText/TinyTitleText.js');
require('../typography/XXLargeDarkText/XXLargeDarkText.js');
require('../buttons/AddAttachmentsButton/AddAttachmentsButton.js');
require('../buttons/BlueTextButton/BlueTextButton.js');
require('../buttons/BackButton/BackButton.js');
var BorderlessButton = require('../buttons/BorderlessButton/BorderlessButton.js');
require('../buttons/ButtonAndStatus/ButtonAndStatus.js');
require('../buttons/ButtonGroup/ButtonGroup.js');
require('../buttons/DialogPrimaryButton/DialogPrimaryButton.js');
require('../buttons/DialogSecondaryButton/DialogSecondaryButton.js');
require('../buttons/DialogWarningButton/DialogWarningButton.js');
require('../buttons/FormButton/FormButton.js');
require('../buttons/IconButtonWithDropDown/IconButtonWithDropDown.js');
require('../buttons/PillButton/PillButton.js');
require('../buttons/PrimaryButton/PrimaryButton.js');
require('../buttons/TwoToneButton/TwoToneButton.js');
require('../buttons/WarningButton/WarningButton.js');
require('../buttons/AvatarButtons/ButtonWithAvatar/ButtonWithAvatar.js');
require('../buttons/AvatarButtons/AvatarWithSubtitle/AvatarWithSubtitle.js');
require('../buttons/AvatarButtons/VerticalAvatar/VerticalAvatar.js');
require('../inputs/utils/highlight.js');
require('../inputs/SelectWithLabel/SelectWithLabel.js');
var CardRow = require('../CardRow/CardRow.js');
require('../inputs/ToggleSwitch/ToggleSwitch.js');
require('../inputs/InputSelect/InputSelect.js');
require('../inputs/TimeInputSelect/TimeInputSelect.js');
require('../inputs/ActiveWeekdayHours/ActiveWeekdayHours.js');
require('../inputs/InputWithTopLabel/InputWithTopLabel.js');
require('../inputs/SelectWithTopLabel/SelectWithTopLabel.js');
require('../inputs/AddressInput/AddressInput.js');
require('../inputs/AddressInputWithValidation/validators.js');
require('../inputs/AddressInputWithValidation/AddressInputWithValidation.js');
require('../inputs/AsyncMultiSelectControlled/AsyncMultiSelectControlled.js');
require('../inputs/AsyncMultiSelectWithTopLabel/AsyncMultiSelectWithTopLabel.js');
require('../inputs/AsyncSelectWithTopLabel/AsyncSelectWithTopLabel.js');
var InputCheckbox = require('../inputs/InputCheckbox/InputCheckbox.js');
require('../inputs/InputTextarea/InputTextarea.js');
require('../inputs/InputWithIcon/InputWithIcon.js');
require('../inputs/InputWithLeftMenu/InputWithLeftMenu.js');
require('../inputs/ListSelect/ListSelect.js');
require('../inputs/MultiSelectMenu/MultiSelectMenu.js');
require('../inputs/MultiSelectWithTopLabel/MultiSelectWithTopLabel.js');
require('../inputs/NumberSelect/NumberSelect.js');
require('../inputs/OutlinedInputWithIcon/OutlinedInputWithIcon.js');
require('../inputs/OutlinedInputWithTopLabel/OutlinedInputWithTopLabel.js');
require('../inputs/PhoneNumberInputWithTopLabel/PhoneNumberInputWithTopLabel.js');
require('../inputs/RadioButtonGroup/RadioButtonGroup.js');
require('../inputs/ConfirmationMultiSelectMenu/ConfirmationSelectMenu.js');
var StarScores = require('../StarScores/StarScores.js');
var FilterListIcon = _interopDefault(require('@material-ui/icons/FilterList'));
var styledComponents = require('./styled-components.js');

var ReviewsSectionTitle = function (props) {
    var filtered = props.filtered, reviewLength = props.reviewLength, moreReviews = props.moreReviews, _a = props.currentSelections, currentSelections = _a === void 0 ? [] : _a, reporter = props.reporter, totalFacebook = props.totalFacebook, totalGoogle = props.totalGoogle, _b = props.controlled, controlled = _b === void 0 ? false : _b;
    var id = 'filter_popover';
    var _c = React__default.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleReset = function () {
        reporter(null); // Reporter, if passed null should clear.
    };
    var initiallyChecked = function (reviewType) {
        if (currentSelections.includes(reviewType)) {
            return true;
        }
        if (!currentSelections.includes('google') && !currentSelections.includes('facebook')) {
            return true;
        }
        return false;
    };
    var open = Boolean(anchorEl);
    // TODO: internationalize
    return (React__default.createElement(CardRow, { left: React__default.createElement("div", { style: { display: 'flex' } },
            React__default.createElement(MediumEmphasizedDarkText, { style: { fontSize: '17px' } }, filtered ? 'Filtered Reviews' : 'All Reviews'),
            React__default.createElement(MediumText, { style: { marginLeft: '0.5rem', fontSize: '17px' } },
                "\u00A0",
                reviewLength,
                moreReviews ? ' +' : ' total')), right: React__default.createElement(styledComponents.Container, null,
            React__default.createElement(SecondaryButton, { style: { width: '83px', height: '30px' }, "aria-describedby": id, onClick: handleClick, title: 'Filters', icon: React__default.createElement(FilterListIcon, null) }),
            React__default.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                } },
                React__default.createElement("div", { style: {
                        width: '260px',
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: '8px',
                        paddingLeft: '8px',
                        borderBottom: '1px solid #e3ebf6',
                    } },
                    React__default.createElement(InputCheckbox, { label: React__default.createElement("span", { style: { color: '#4c7cfd' } },
                            "Facebook ",
                            totalFacebook && "(" + totalFacebook + ")"), controlled: controlled, onChange: function () { return reporter('facebook'); }, initiallyChecked: initiallyChecked('facebook') }),
                    React__default.createElement(InputCheckbox, { label: React__default.createElement("span", { style: { color: '#4c7cfd' } },
                            "Google ",
                            totalGoogle && "(" + totalGoogle + ")"), onChange: function () { return reporter('google'); }, controlled: controlled, initiallyChecked: initiallyChecked('google') })),
                React__default.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: '8px',
                        borderBottom: '1px solid #e3ebf6',
                    } }, [1, 2, 3, 4, 5].map(function (v) { return (React__default.createElement(InputCheckbox, { key: v, label: React__default.createElement(StarScores, { averageRating: v, style: { marginBottom: '3px', width: '100px' }, fontSize: '1.7em', backgroundHidden: true, readOnly: true }), controlled: controlled, onChange: function () { return reporter(v); }, initiallyChecked: currentSelections.includes(v) })); })),
                React__default.createElement("div", null,
                    React__default.createElement(BorderlessButton, { title: React__default.createElement(SmallDarkText, { style: { width: '260px', padding: '2px' } }, "Reset"), onClick: handleReset, style: {
                            textAlign: 'left',
                            width: '100%',
                            paddingTop: '12px',
                            paddingBottom: '16px',
                        } })))), style: { alignItems: 'center' } }));
};

module.exports = ReviewsSectionTitle;
